import ReducerBuilder from 'classes/ReducerBuilder';
import editBreakReducerInitialState from './initialState';
import {Types} from './actions';
import {TopLevelSectionName} from 'utils/DBUtils';
import * as SectionReductions from 'utils/sectionManagement/reductions';
import {Types as SectionActions} from 'utils/sectionManagement/actions';
import {isNoU} from "../../utils/DBUtils";

const reducer = ReducerBuilder.make(editBreakReducerInitialState)
    .forType(Types.REQUEST_BREAK)
    .reduce((state, action) => {
        state.selectedChallengeId = action.challengeId;
        return state;
    })
    .forType("RECEIVED_ALL_RESOURCES_BREAK")
    .reduce((state, action) => {
        state.break = {};
        for (let brk of action.resources) {
            state.break[brk.platform] = brk.id;
        }
    })
    .forType(Types.EDIT_BREAK_UNMOUNTED)
    .reduce((state, action) => {
        state.break = null;
        return state;
    })
    .forType(Types.START_DISPLAY_ORDER_SAVE)
    .reduce((state, action) => {
        state.savingDisplayOrder = true;
    })
    .forType(Types.END_DISPLAY_ORDER_SAVE)
    .reduce((state, action) => {
        state.savingDisplayOrder = false;
    })
    .forType(Types.START_RENAME_STEP)
    .reduce((state, {step, index}) => {
        state.renamingStep = {step, index};
    })
    .forType(Types.END_RENAME_STEP)
    .reduce((state, action) => {
        state.renamingStep = null;
    })
    .forType(Types.GET_BREAK_IMAGES_PAGE)
    .reduce((state, action) => {
        state.lastBreakImagesPage = action.page || state.lastBreakImagesPage;
        state.lastBreakImagesCount = action.count || state.lastBreakImagesCount;
        state.lastBreakImagesId = action.breakId || state.lastBreakImagesId;
    })
    .forType(Types.GET_ALL_BREAK_IMAGES).reduce((state, action) => state)
    .forType(Types.ERROR_CREATING_PALETTE)
    .reduce((state, action) => {
      state.hasError = true;
      state.formErrorCreatingPalette = action.formError;
    })
    .forType(Types.SUCCESS_CREATING_PALETTE)
    .reduce((state, action) => {
      state.createPaletteSuccess = true;
    })

    .forType(SectionActions.TOGGLE_SECTION_OPEN)
    .reduce(SectionReductions.toggleSectionOpen)

    .forType(SectionActions.REGISTER_SECTION)
    .reduce(SectionReductions.registerSection)

    .forType(SectionActions.UNREGISTER_SECTION)
    .reduce(SectionReductions.unregisterSection)

    .forType(Types.SEARCH_BREAK_TAGS)
    .reduce((state, action) => {
        state.breakTagSearchText = action.searchText;
    })
    .forType(Types.RECEIVED_BREAK_TAGS)
    .reduce((state, action) => {
        state.breakTags = action.tags;
    })
    .forType(Types.ADD_BREAK_TAG)
    .reduce((state, action) => {
        state.addingTagCount = state.addingTagCount + 1;
        // clear out search
        state.breakTagSearchText = "";
    })
    .forType(Types.BREAK_TAG_ADDED)
    .reduce((state) => {
        state.addingTagCount = state.addingTagCount - 1;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/EditBreak/edit-break-reducer.js